import { Badge, Checkbox, InlineStack, Tooltip } from "@shopify/polaris";
export const TRAFFICARMOR_TYPE_GROUPS = [
  {
    key: "recommended",
    title: "Recommended blocks",
    description: "Automated or non-customer traffic",
  },
  {
    key: "strict",
    title: "Optional strict blocks",
    description: "May include legitimate customers",
  },
  {
    key: "customer",
    title: "Customer networks",
    description: "Keep allowed to reduce false positives",
  },
  {
    key: "observed",
    title: "Other observed types",
    description: "Returned by TrafficArmor and collected in the IP library",
  },
];

export const TrafficArmorTypeRule = ({ option, blockedTypes, loading, onChange }) => {
  const codes = Array.isArray(option.codes) && option.codes.length > 0
    ? option.codes
    : [option.code];
  const checked = codes.some((code) => blockedTypes.includes(code));
  const allowedTone = option.group === "customer" ? "success" : undefined;

  return (
    <InlineStack align="space-between" blockAlign="center" gap="200" wrap={false}>
      <Checkbox
        label={(
          <Tooltip
            content={option.description}
            accessibilityLabel={`About ${option.label}`}
            preferredPosition="above"
            width="wide"
            hasUnderline
          >
            <span tabIndex={0}>{option.label}</span>
          </Tooltip>
        )}
        checked={checked}
        onChange={(value) => onChange(codes, value)}
        disabled={loading}
      />
      <InlineStack gap="150" blockAlign="center" wrap={false}>
        <Badge>{option.code_label || codes.join(" / ")}</Badge>
        <Badge tone={checked ? "critical" : allowedTone}>{checked ? "Block COD" : "Allowed"}</Badge>
      </InlineStack>
    </InlineStack>
  );
};

